<style scoped></style>

<template>
  <div>
    <ul>
      <li v-for="(option, i) in currentValue" v-bind:key="i" class="py-2">
        <div class="flex justify-between">
          <div class="flex-shrink-0 flex items-center">
            <svg
              class="w-2 mr-2 text-gray-300 cursor-move"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
            >
              <path
                fill="currentColor"
                d="M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
              />
            </svg>
          </div>
          <select
            v-model="currentValue[i].type"
            class="ml-1 flex form-select transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          >
            <option value="text">
              {{ $t('fields.short_text') }}
            </option>
            <option value="number">
              {{ $t('fields.number') }}
            </option>
            <option value="dropdown">
              {{ $t('fields.dropdown') }}
            </option>
          </select>

          <input
            type="text"
            v-model="currentValue[i].label"
            :placeholder="$t('fields.label_placeholder')"
            class="ml-1 flex-1 form-input transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          />

          <button
            class="m-1"
            @click="
              (e) => {
                e.preventDefault();
                removeRow(i);
              }
            "
            :aria-label="$t('fields.remove_row')"
          >
            <svg
              class="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div class="ml-5">
          <div class="mt-4">
            <label class="block text-sm font-medium text-gray-700">{{
              $t('fields.internal_id')
            }}</label>
            <input
              type="text"
              v-model="currentValue[i].id"
              :placeholder="$t('fields.internal_id')"
              class="form-input w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            />
          </div>

          <div v-if="currentValue[i].type == 'dropdown'" class="mt-4">
            <label class="block text-sm font-medium text-gray-700">{{
              $t('fields.options')
            }}</label>
            <OptionsField
              field="field"
              v-model="currentValue[i].options"
              class="mt-1"
            />
          </div>
        </div>
      </li>
      <div class="text-right">
        <button
          class="btn-secondary mt-2"
          @click="
            (e) => {
              e.preventDefault();
              addRow();
            }
          "
        >
          {{ $t('fields.add_array_field') }}
        </button>
      </div>
    </ul>
  </div>
</template>

<script>
import OptionsField from './OptionsField.vue';

export default {
  name: 'ArrayField',
  components: {
    OptionsField,
  },
  props: {
    value: Array,
  },
  data() {
    return {
      currentValue: this.value ? this.value : [],
    };
  },
  methods: {
    addRow() {
      this.currentValue.push({});
    },
    removeRow(i) {
      this.$delete(this.currentValue, i);
    },
  },
};
</script>
